import { ridSegment } from '@krp/client-runtime'

/** Адреса кассовых смен базы 1С (раздел «Смены»). Литерал `/api/` законен только здесь. */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}/receipts/shifts`

export const ONEC_SHIFTS_URLS = {
  /** Смены за период (не длиннее 31 дня); кассы узла — `registerKey` повторяется, пусто — все кассы базы. */
  list: (resourceId: string, from: string, to: string, registerKeys: readonly string[] = []) => {
    const query = new URLSearchParams({ from, to })
    for (const key of registerKeys) query.append('registerKey', key)
    return `${base(resourceId)}?${query.toString()}`
  },
} as const
